export class PrivyWallet {
  uuid!: string;
  external_id!: string;
  address!: string;
  created_at!: string;

  constructor(data: any = {}) {
    this.build(data);
  }

  private build(data: any = {}) {
    this.uuid = data.uuid;
    this.external_id = data.external_id;
    this.address = data.address;
    this.created_at = data.created_at;
  }
}
